import type { RegistrationDetails } from '@words-happen/screens';
import { loadEmailAuth } from './load-email-auth';
import type { VerificationOptions } from './sign-in-with-email';

export interface RegistrationResult {
  /** False when the account exists but the verification email couldn't be sent; the player can resend it. */
  verificationSent: boolean;
}

/**
 * Creates an account with a display name, email and password, leaves the player signed in, and sends the
 * verification email; rejects with the Firebase error when the account can't be created.
 */
export type RegisterWithEmail = (
  details: RegistrationDetails,
  options: VerificationOptions,
) => Promise<RegistrationResult>;

/** Identity Platform email registration (email-auth.ts), loading the Firebase SDK on first use. */
export const registerWithEmail: RegisterWithEmail = async (details, options) =>
  (await loadEmailAuth()).registerWithEmail(details, options);
